import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'EntitySubType/List', method: 'GET', body: null, token: token })
}
